import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { CurrencyModel } from '@root/entities/currency'
import { selectedNetworkAtom } from '@root/entities/network'
import { WalletBalanceBadge } from '@root/entities/wallet/ui/desktop'
import { openBackOfficeUsersWalletsModalEvent } from '@root/features/back-office/user-wallets/atoms/back-office-users-wallets-modal-event'
import { BackOfficeRefreshUsersWalletsButton } from '@root/features/back-office/user-wallets/ui/refresh-users-wallets-button'
import { CopyButton, Truncate } from '@root/shared/ui-kit'

import { TwoRowsTextCell } from './two-rows-text-cell'

import type { BackOfficeUser } from '@root/entities/back-office'

export const WalletsCell = (props: { user: BackOfficeUser.BackOfficeUser }) => {
  const [selectedNetwork] = useAtom(selectedNetworkAtom)
  const openBackOfficeUsersWalletsModal = useAction(
    openBackOfficeUsersWalletsModalEvent,
  )
  const [walletsOfSelectedNetwork] = useAtom(
    props.user.walletsOfSelectedNetworkAtom,
  )
  const [headWallet] = walletsOfSelectedNetwork

  return (
    <TwoRowsTextCell
      firstRow={
        headWallet ? (
          <Top>
            <BackOfficeRefreshUsersWalletsButton
              wallets={walletsOfSelectedNetwork.map((wallet) => ({
                delugeId: props.user.delugeId,
                walletId: wallet.id,
              }))}
            />
            <WalletBalanceBadge
              wallet={headWallet}
              currency={CurrencyModel.nativeOf(selectedNetwork)}
              onClick={() =>
                openBackOfficeUsersWalletsModal({
                  user: props.user,
                })
              }
            />
          </Top>
        ) : (
          '—'
        )
      }
      secondRow={
        headWallet ? (
          <IdCell>
            <CopyButton value={headWallet.id} />
            <Truncate start={6} end={8}>
              {headWallet.id}
            </Truncate>
          </IdCell>
        ) : undefined
      }
    />
  )
}

const Top = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`
const IdCell = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`
